import React from "react";
import { i18n } from "../../../translate/i18n";
import { User, UserTypes } from "definitions/User";
import { Ticket } from "definitions/Ticket";
import { StatusUserEnum } from "definitions/Others";

function isActionAllowed(user: User, ticket: Ticket): boolean {
  // explicit flag has max priority
  if (!user.allowAssumeTickets) return false;

  // if ticket has no agent, everyone except for agents can take over
  if (!ticket.User) {
    return !(
      user.UserTypeId === UserTypes["Atendente"] ||
      user.UserTypeId === UserTypes["Atendente IH"] ||
      user.UserTypeId === UserTypes["Atendente(14)"] ||
      user.UserTypeId === UserTypes["Atendente IH(15)"]
    );
  }

  // closed tickets cannot be taken over
  if (ticket.CompanyStatus.statusUser === StatusUserEnum.Concluido)
    return false;

  // not necessary to change ticket owner to self
  if (user.id === ticket.AgentId) return false;

  // if ticket is under bot control...
  if (ticket.User.UserTypeId === UserTypes.BOT) {
    // only managers can take over
    return (
      user.UserTypeId === UserTypes["Gerente IH"] ||
      user.UserTypeId === UserTypes["Gerente"]
    );
  }

  // default rule: if ticket is not under bot control, anyone can take over
  return true;
}

type BtnTakeOverProps = {
  user: User;
  ticket: Ticket;
  onClickHandler: (id: Ticket["id"], ticket: Ticket["ticket"]) => any;
};

export function BtnTakeOver(props: BtnTakeOverProps): JSX.Element {
  const { user, ticket, onClickHandler } = props;

  if (!isActionAllowed(user, ticket)) return <></>;

  return (
    <button
      className="btn btn-outline-success"
      onClick={() => onClickHandler(ticket.id, ticket.ticket)}
    >
      {i18n.t("assumeTicket") as string}
    </button>
  );
}

/**
 * refactored from convoluted boolean logic:
 * (user.UserTypeId === UserTypes["Atendente(14)"] ||
 * (user.UserTypeId === UserTypes["Atendente IH(15)"] &&
 *   ticketData.User.UserTypeId !== UserTypes.BOT)) &&
 * user.id !== ticketData.AgentId &&
 * ticketData.CompanyStatus.statusUser !== 4 &&
 * user.allowAssumeTickets
 */
